import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { HttpCacheService } from '@common-modules/cache/http-cache/http-cache.service';
import { AuthenticationService } from '@common-modules/shared/auth/services/authentication.service';
import { SettingsService } from '@common-modules/shared/config/settings.service';
import { VersionInfoPopupDimensions } from '@common-modules/shared/constants/dimensions.constants';
import { CustomThemes } from '@common-modules/shared/theme/custom-themes';
import { ThemeService } from '@common-modules/shared/theme/theme.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { VersionInfoPopupComponent } from '../version-info-popup/version-info-popup.component';

const COMPONENT_SELECTOR = 'tc-main-account-card';

@UntilDestroy()
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './main-account-card.component.html',
  styleUrls: ['./main-account-card.component.scss'],
  standalone: false,
})
export class MainAccountCardComponent implements OnInit {
  T_SCOPE = `${TranslateScopes.MainLayout}.${COMPONENT_SELECTOR}`;
  today = new Date();
  theme: CustomThemes;
  darkThemeSliderChecked: boolean;

  constructor(
    private _authService: AuthenticationService,
    private _cacheService: HttpCacheService,
    private _settingsService: SettingsService,
    private readonly _themeService: ThemeService,
    private matDialog: MatDialog
  ) {}

  ngOnInit(): void {
    this._themeService.theme$.pipe(untilDestroyed(this)).subscribe((theme) => {
      this.theme = theme;
      this.darkThemeSliderChecked = theme === CustomThemes.Dark;
    });
  }

  logOut(): void {
    this._authService.logout(() => {});
  }

  cleanCache() {
    localStorage.clear();
    this._cacheService.clear();
  }

  navigatetoUserPage() {
    const url = this._settingsService.oAuthConfig.issuer;
    window.open(url, '_blank');
  }

  toggleDarkTheme(): void {
    const nextTheme = this.theme === CustomThemes.Dark ? CustomThemes.Default : CustomThemes.Dark;
    this._themeService.setTheme(nextTheme);
    this.darkThemeSliderChecked = nextTheme === CustomThemes.Dark;
  }

  openVersionPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = VersionInfoPopupDimensions.Width;
    // dialogConfig.height = VersionInfoPopupDimensions.Height;

    const popup = this.matDialog.open(VersionInfoPopupComponent, dialogConfig);
  }
}
